
const ths = ({ isOffline, showCountry, showOA, isLabelsEnabled, isOrgLabelsEnabled, isContactLabelsEnabled, isAwardLabelsEnabled } = {}) => [
  {
    id: 1,
    label: 'ID',
    intlKey: 'table.id',
    sortableId: 'id'
  },
  {
    id: 2,
    label: 'First name',
    intlKey: 'table.first_name',
    sortableId: 'award.participant.firstName'
  },
  {
    id: 3,
    label: 'Last name',
    intlKey: 'table.last_name',
    sortableId: 'award.participant.lastName'
  },
  {
    id: 4,
    label: 'Previous Level',
    intlKey: 'table.previous_level',
    sortable: false
  },
  {
    id: 5,
    label: 'Current Level',
    intlKey: 'table.current_level',
    sortable: false
  },
  {
    id: 6,
    label: 'Award Unit',
    intlKey: 'table.award_unit',
    sortable: false,
    sortableId: 'award.organization.name'
  },
  {
    id: 7,
    label: 'Stard Date',
    intlKey: 'table.start_date',
    sortable: false
  },
  {
    id: 8,
    label: 'Date Submitted to Award Office Sign-off',
    intlKey: 'table.date_submitted_to_office_signoff',
    sortableId: 'award.leaderSignoffDate'
  },
  {
    id: 9,
    label: 'Country',
    intlKey: 'table.country',
    sortableId: 'award.organization.country.name',
    hide: !showCountry
  },
  {
    id: 10,
    label: 'Operating Authority',
    intlKey: 'table.operating_authority',
    sortableId: 'organization.parentOA.name',
    hide: !showOA
  },
  {
    id: 11,
    label: 'Sub-Operating Authority',
    intlKey: 'table.suboperating_authority',
    sortableId: 'organization.parentOA.name'
  },
  {
    id: 12,
    label: 'Award Signoff Attempts',
    intlKey: 'table.award_signoff_attempts',
    sortableId: 'award.signoffRequestAttemptsCount'
  },
  {
    id: 13,
    label: 'Labels',
    intlKey: 'table.labels',
    sortableId: 'labels.label.name',
    hide: !isLabelsEnabled
  },
  {
    id: 14,
    label: 'Organization Labels',
    intlKey: 'table.organization_labels',
    sortableId: 'organization.labels.label.name',
    hide: !isOrgLabelsEnabled
  },
  {
    id: 15,
    label: 'Award Leader Labels',
    intlKey: 'table.contact_labels',
    sortableId: 'awardLeader.labels.label.name',
    hide: !isContactLabelsEnabled
  },
  {
    id: 16,
    label: 'Award Labels',
    intlKey: 'table.award_labels',
    sortableId: 'award.labels.label.name',
    hide: !isAwardLabelsEnabled
  },
  {
    id: 17,
    label: 'Note from AL',
    intlKey: 'table.note_from_al',
    sortable: false
  },
  {
    id: 18,
    label: 'Award mode',
    intlKey: 'table.award_mode',
    sortable: false,
    hide: !isOffline
  },
  {
    id: 19,
    label: 'Award type',
    intlKey: 'table.award_type',
    sortable: false
  },
  {
    id: 20,
    label: 'Action',
    intlKey: 'table.action',
    sortable: false
  }
]

export default ths
